import { GTM_ID } from '../constants';

export const gtm = `
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${GTM_ID}');
`;

// Read by the exception trigger of the CookieYes tag in GTM, so it has to be in dataLayer before gtm.js loads
const cookieYesDisabled = `
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ cookieyes_disabled: true });
`;

export const getGtmScript = (withCookieYesDisabled: boolean): string => {
  if (!GTM_ID) return '';
  if (withCookieYesDisabled) return `${cookieYesDisabled}${gtm}`;

  return gtm;
};
